import { KeycloakService } from 'keycloak-angular';

const LOGIN_REDIRECT_KEY = 'keycloak-login-redirect-at';
const LOGIN_REDIRECT_TTL_MS = 30000;

const isLoginRedirectActive = () => {
  const startedAt = Number(sessionStorage.getItem(LOGIN_REDIRECT_KEY));
  if (!startedAt) {
    return false;
  }

  if (Date.now() - startedAt > LOGIN_REDIRECT_TTL_MS) {
    sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
    return false;
  }

  return true;
};

export const clearKeycloakLoginRedirect = () => {
  sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
};

export const keycloakLogin = async (keycloakService: KeycloakService) => {
  if (isLoginRedirectActive()) {
    return;
  }

  sessionStorage.setItem(LOGIN_REDIRECT_KEY, String(Date.now()));
  await keycloakService.login();
};
